
import R from "../assets/png/R.png"


export const experienceData = [
  {
    id: 1,
    company: "Ram Handling",
    jobtitle: {
      en: "Software Engineer Intern",
      fr: "Stagiaire Ingénieur Logiciel",
    },
    startYear: "2025-07-01",
    endYear: "2025-09-01",
    jobDesc: {
      en: "Internship at RAM Handling focused on designing and developing a maintenance management platform. Worked on backend and frontend integration, database modeling, and deployment using Docker.",
      fr: "Stage chez RAM Handling axé sur la conception et le développement d’une plateforme de gestion de maintenance. Participation à l’intégration backend/frontend, à la modélisation de la base de données et au déploiement avec Docker.",
    },
    logo:R
  },
];
